var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.contextOther, function(item, index) {
      return _c("div", { key: item.id }, [
        item.type === "transport"
          ? _c(
              "div",
              { staticClass: "px-2" },
              [
                _c(
                  "v-row",
                  {
                    staticClass: "flex-nowrap",
                    attrs: { justify: "center", "no-gutters": "" }
                  },
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "v-row",
                          { attrs: { dense: "" } },
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "4" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    label: _vm.$t(
                                      "delegation.form.fields.other.billDescription.name"
                                    ),
                                    "error-messages":
                                      _vm.contextErrors[index].bill_description,
                                    readonly:
                                      _vm.$store.state.Delegation.readonly ===
                                      true
                                  },
                                  model: {
                                    value: item.bill_description,
                                    callback: function($$v) {
                                      _vm.$set(item, "bill_description", $$v)
                                    },
                                    expression: "item.bill_description"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "2" } },
                              [
                                _c("v-autocomplete", {
                                  attrs: {
                                    items: _vm.payment_types,
                                    "item-text": "name",
                                    "item-value": "id",
                                    label: _vm.$t(
                                      "delegation.form.fields.other.paymentType.name"
                                    ),
                                    clearable:
                                      _vm.$store.state.Delegation.readonly !==
                                      true,
                                    "error-messages":
                                      _vm.contextErrors[index].payment_type_id,
                                    readonly:
                                      _vm.$store.state.Delegation.readonly ===
                                      true
                                  },
                                  model: {
                                    value: item.payment_type_id,
                                    callback: function($$v) {
                                      _vm.$set(item, "payment_type_id", $$v)
                                    },
                                    expression: "item.payment_type_id"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "3" } },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    label: _vm.$t(
                                      "delegation.form.fields.other.billNumber.name"
                                    ),
                                    "error-messages":
                                      _vm.contextErrors[index].bill_number,
                                    readonly:
                                      _vm.$store.state.Delegation.readonly ===
                                      true
                                  },
                                  model: {
                                    value: item.bill_number,
                                    callback: function($$v) {
                                      _vm.$set(item, "bill_number", $$v)
                                    },
                                    expression: "item.bill_number"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "3" } },
                              [
                                _c("date-picker", {
                                  attrs: {
                                    label: _vm.$t(
                                      "delegation.form.fields.other.billDate.name"
                                    ),
                                    model: item.bill_date,
                                    dateValidation:
                                      _vm.contextErrors[index].bill_date,
                                    readonly:
                                      _vm.$store.state.Delegation.readonly ===
                                      true
                                  },
                                  on: {
                                    "update:model": function($event) {
                                      return _vm.$set(item, "bill_date", $event)
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                attrs: {
                                  cols: "12",
                                  md:
                                    !!item.type_id &&
                                    _vm.transport_types.find(function(v) {
                                      return v.id === item.type_id
                                    }).isVehicleTypeRequired
                                      ? 4
                                      : 6
                                }
                              },
                              [
                                _c("v-select", {
                                  attrs: {
                                    label: _vm.$t(
                                      "delegation.form.fields.other.type.name"
                                    ),
                                    items: _vm.transport_types,
                                    "item-text": "name",
                                    "error-messages":
                                      _vm.contextErrors[index].type_id,
                                    "item-value": "id",
                                    readonly:
                                      _vm.$store.state.Delegation.readonly ===
                                      true
                                  },
                                  model: {
                                    value: item.type_id,
                                    callback: function($$v) {
                                      _vm.$set(item, "type_id", $$v)
                                    },
                                    expression: "item.type_id"
                                  }
                                })
                              ],
                              1
                            ),
                            !!item.type_id &&
                            _vm.transport_types.find(function(v) {
                              return v.id === item.type_id
                            }).isVehicleTypeRequired
                              ? _c(
                                  "v-col",
                                  { attrs: { cols: "12", md: "2" } },
                                  [
                                    _c("v-autocomplete", {
                                      attrs: {
                                        items: _vm.vehicleTypes,
                                        "item-text": "name",
                                        "item-value": "id",
                                        label: _vm.$t(
                                          "delegation.form.fields.vehicleType.name"
                                        ),
                                        clearable:
                                          _vm.$store.state.Delegation
                                            .readonly !== true,
                                        "error-messages": !!item.vehicle_type_id
                                          ? []
                                          : [_vm.$t("global.error.required")],
                                        readonly:
                                          _vm.$store.state.Delegation
                                            .readonly === true
                                      },
                                      model: {
                                        value: item.vehicle_type_id,
                                        callback: function($$v) {
                                          _vm.$set(item, "vehicle_type_id", $$v)
                                        },
                                        expression: "item.vehicle_type_id"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "v-col",
                              { attrs: { cols: "8", md: "2" } },
                              [
                                _c("AmountInput", {
                                  attrs: {
                                    "error-messages":
                                      _vm.contextErrors[index]
                                        .amount_in_currency,
                                    model: item.amount_in_currency,
                                    label: _vm.$t("global.grossAmount"),
                                    readonly:
                                      _vm.$store.state.Delegation.readonly ===
                                      true
                                  },
                                  on: {
                                    "update:model": function($event) {
                                      return _vm.$set(
                                        item,
                                        "amount_in_currency",
                                        $event
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "4", md: "1" } },
                              [
                                _c("currency-select", {
                                  attrs: {
                                    model: item.currency,
                                    "validation-message":
                                      _vm.contextErrors[index].currency,
                                    readonly:
                                      _vm.$store.state.Delegation.readonly ===
                                      true
                                  },
                                  on: {
                                    "update:model": function($event) {
                                      return _vm.$set(item, "currency", $event)
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "3" } },
                              [
                                _c("ajax-single-file", {
                                  attrs: {
                                    accept:
                                      _vm.$store.getters[
                                        "Delegation/allowedAttachmentFileFormat"
                                      ],
                                    items: _vm.fileProperties(item.file_id),
                                    model: item.file_id,
                                    readonly:
                                      _vm.$store.state.Delegation.readonly ===
                                      true
                                  },
                                  on: {
                                    "update:model": function($event) {
                                      return _vm.$set(item, "file_id", $event)
                                    },
                                    fileUploaded: _vm.addFileToDelegationFiles,
                                    fileRemoved:
                                      _vm.removeFileFromDelegationFiles
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "4" } },
                              [
                                _c("v-checkbox", {
                                  attrs: {
                                    label: _vm.$t(
                                      "delegation.form.fields.invoiceForEmployer.name"
                                    ),
                                    readonly:
                                      _vm.$store.state.Delegation.readonly ===
                                      true
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "append",
                                        fn: function() {
                                          return [
                                            _c(
                                              "v-tooltip",
                                              {
                                                attrs: { bottom: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function(ref) {
                                                        var on = ref.on
                                                        return [
                                                          _c(
                                                            "v-icon",
                                                            _vm._g({}, on),
                                                            [_vm._v("info")]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "delegation.form.fields.invoiceForEmployer.tooltip"
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    true
                                  ),
                                  model: {
                                    value: item.is_invoice_for_employer,
                                    callback: function($$v) {
                                      _vm.$set(
                                        item,
                                        "is_invoice_for_employer",
                                        $$v
                                      )
                                    },
                                    expression: "item.is_invoice_for_employer"
                                  }
                                })
                              ],
                              1
                            ),
                            item.is_invoice_for_employer
                              ? _c(
                                  "v-col",
                                  { attrs: { cols: "8", md: "2" } },
                                  [
                                    _c("AmountInput", {
                                      attrs: {
                                        "error-messages":
                                          _vm.contextErrors[index]
                                            .net_amount_in_currency,
                                        model: item.net_amount_in_currency,
                                        label: _vm.$t("global.netAmount"),
                                        readonly:
                                          _vm.$store.state.Delegation
                                            .readonly === true
                                      },
                                      on: {
                                        "update:model": function($event) {
                                          return _vm.$set(
                                            item,
                                            "net_amount_in_currency",
                                            $event
                                          )
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("v-spacer"),
                    _vm.clearable
                      ? _c(
                          "v-col",
                          { staticClass: "d-flex align-center justify-center" },
                          [
                            _c(
                              "v-tooltip",
                              {
                                staticClass: "hidden-sm-and-down",
                                attrs: { top: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                attrs: { icon: "" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.removeOther(item)
                                                  }
                                                }
                                              },
                                              on
                                            ),
                                            [_c("v-icon", [_vm._v("close")])],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("global.removeItem")) +
                                    " "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm.clearable
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "hidden-md-and-up",
                        on: {
                          click: function($event) {
                            return _vm.removeOther(item)
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("global.removeItem")) + " ")]
                    )
                  : _vm._e(),
                _vm.contextOther.indexOf(item) !== _vm.contextOther.length - 1
                  ? _c("v-divider", { staticClass: "mb-2" })
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }